<template>
  <div v-if="!fetching" class="card-guide">
    <div class="card-guide-body">
      <div class="d-flex justify-content-between">
        <add-edit-modal
            :ref="itemModal"
            :modal-id="itemModal"
            :profile="profile"
            :care-plan="selectedCarePlan"
            :root-path-doc="rootPathDoc"
            :type="type"
        />
        <span class="search">
          <label>
            <img
                :src="searchIconSVG"
            />
            <input
                type="search"
                class="search-input"
                placeholder="Search Automations"
                v-model="searchStr"
            />
          </label>
        </span>
      </div>
      <div class="sessions" role="tablist">
        <item-row-card
            v-for="(anItem, idx) in items"
            :item="anItem"
            :idx="idx"
            :key="`${type}-${idx}`"
            :root-path-doc="rootPathDoc"
            @edit-care-plan-click="handleEditItemModal"
            @delete-care-plan="handleDeleteCarePlan"
            @add-data-click="handleAddDataButtonClick"
        />
      </div>
    </div>
    <vimeo-modal
        v-if="activeVideo"
        :id="authorCarePlanVideo"
        :videoId="activeVideo.videoId"
        :videoThumb="activeVideo.videoThumb ? activeVideo.videoThumb : null"
    />
    <delete-care-plan-modal
        :modal-id="modalIdDelete"
        :item-type="itemTypeDelete"
        :item-name="itemNameDelete"
        :item-id="itemDeleteItemId"
        @delete-item="handleDeleteCarePlanConfirmation"
    />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ItemRowCard from "@/components/_services/automation/rowCard";
import AddEditModal from "@/components/_services/automation/addEditModal";
import DeleteCarePlanModal from "@/components/modals/modalDelete";
import moment from "moment";
import firebase from "firebase";

import vimeoModal from "@/components/common/vimeoModal";
import VideoHandling from "@/mixins/VideoHandling";
import UploadImage from "@/mixins/UploadImage";

export default {
  name: "ManageTab_Automation",
  mixins: [UploadImage, VideoHandling],
  components: {
    ItemRowCard,
    AddEditModal,
    DeleteCarePlanModal,
    vimeoModal
  },
  props: {
    profile: {
      type: Object,
      default: () => {}
    },
    provider: {
      type: Object,
      default: () => {}
    },
    type: {
      type: String,
      default: "automation"
    }
  },
  mounted() {
    this.fetching = false;
    this.$root.$on("bv::collapse::state", (collapseId, isJustShown) => {
      if (this.activeCollapse == collapseId) {
        this.activeCollapse = -1;
      }
      if (isJustShown) {
        this.activeCollapse = collapseId;
      }
    });
  },
  computed: {
    ...mapGetters({}),
    items() {
      return this.listDataDoc  && this.listDataDoc.plans &&
      Array.isArray(this.listDataDoc.plans) ?
          this.listDataDoc.plans:[]
    }
  },
  methods: {
    handleActivation() {
      if (!this.unsub){
        this.setUpSnapShot();
      }
    },
    setUpSnapShot() {
      //@ToDo =- move to store
      if (this.rootPathDoc) {
        const db = firebase.firestore();
        let docRef = db.doc(this.rootPathDoc);

        this.unsub = docRef.onSnapshot(snapshot => {
          this.listDataDoc = snapshot.data();
        });
      }
    },
    handleEditItemModal(item) {
      debugger;
      this.selectedCarePlan = item;
      if ( this.$refs[this.itemModal].hasOwnProperty('showEditItem')) {
        this.$refs[this.itemModal].showEditItem(item);
      }
    },
    async handleProcessCarePlans(jsonCarePlans) {
      // mark source:upload_<userId>_ts
      //Verify that header is valid
      let tStamp = new Date().valueOf();
      if (jsonCarePlans && Array.isArray(jsonCarePlans)) {
        for (const aCarePlan of jsonCarePlans) {
          if (aCarePlan) {
            aCarePlan.source = `upload_${this.profile.userId}_${tStamp}`;
            await this.handleAddCarePlan(aCarePlan)
                .then(response => {
                  this.success.push(aCarePlan.title);
                  console.log(response);
                })
                .catch(err => {
                  console.log(`Error: ${err}`);
                });
          }
        }
      }
    },
    handleDeleteCarePlan(careplan) {
      this.itemNameDelete = careplan.title;
      this.itemTypeDelete = "Publishing";
      this.itemDeleteItemId = careplan.id;
      this.$bvModal.show(this.modalIdDelete);
    },
    handleDeleteCarePlanConfirmation(carePlanId) {
      this.deleteCarePlan(carePlanId);
      //console.log(`Delete ${carePlanId}`);
    },
    handleFeatureClick(featureType, carePlanId) {
      this.selectedCarePlanId = carePlanId;
      this.selectedCarePlan = this.getLocalCarePlanWithId(carePlanId);
      //console.log(`Feature ${featureType} Care Plan: ${this.selectedCarePlanId}`);
      this.$root.$emit("bv::toggle::collapse", featureType);
    },
    handleSelectCarePlanForManagement() {
      this.$store
          .dispatch("user/setSelectedPublishingId", this.selectedCarePlan.id)
          .then(data => {
            // console.log(`Care Plan Id submitted`);
            // console.log(data);
          })
          .catch(error => {
            this.$nprogress.done();
            this.$store.dispatch("user/showNotification", {
              title: error.code,
              description: error.message,
              variant: "danger"
            });
          })
          .finally(() => {
            this.fetching = false;
          });
    },
    handleViewClick(careplan, index) {
      // console.log("here => ", index);
      // this.showDashCard = true;
      this.trackPassing = careplan;
      this.showCard = true;
      this.$bvModal.show(`dashcard-${careplan.id}`);
    },
    formatDate(date) {
      //TODO- Move to mixin
      return date
          ? moment(date.toDate()).format("MMMM DD, YYYY h:MM a")
          : "N/A";
    },
    submitCarePlan(careplan) {
      let carePlanType = "author";

      let owner = {
        firstname: this.profile.firstname ? this.profile.firstname : null,
        lastname: this.profile.lastname ? this.profile.lastname : null,
        imgURL: this.profile.imgURL ? this.profile.imgURL : null,
        profileName: this.profile._dashboards.guide.profileName
            ? this.profile._dashboards.guide.profileName
            : null, //will be global
        userId: this.profile.userId ? this.profile.userId : null
      };

      this.$store
          .dispatch("listings/submitPublishing", {
            careplan,
            owner,
            carePlanType
          })
          .then(res => {
            if (res) {
              this.$store
                  .dispatch("user/submitPublishing", careplan)
                  .then(res => {
                    //this.getCarePlans();
                    this.$store.dispatch("user/showNotification", {
                      title: "Care Plan Submitted Successfully",
                      description:
                          "Your care plan has now been submitted for Review",
                      variant: "success"
                    });
                  });
            }
          });
    },
    deleteCarePlan(id) {
      this.$store.dispatch("user/deletePublishing", id).then(res => {
        if (res) {
          this.$bvModal.hide(this.modalIdDelete);
          //this.getCarePlans();
          this.del = false;
          this.$store.dispatch("user/showNotification", {
            title: "Care Plans Updated Successfully",
            description: "Awesome",
            variant: "success"
          });
        }
      });
    },
    showDeleteCarePlan(i) {
      this.del = true;
      this.activeIndex = i;
      this.$bvModal.show(this.itemModal);
    },
    hideDeleteCarePlan() {
      this.$bvModal.hide(this.itemModal);
    },
    hideCarePlanModal(id) {
      this.$bvModal.hide(`dashcard-${id}`);
    },
    cancelAction() {
      this.resetForm();
      this.$bvModal.hide(this.itemModal);
      this.refresh++;
    },
    getCarePlanId(length) {
      //move to mixin
      var result = "";
      var characters =
          "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
            Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    },
    resetForm() {
      this.careplan = {
        title: "",
        subtitle: "",
        description: "",
        seo: [],
        spheres: [],
        tools: [],
        guides: [],
        connections: [],
        engines: [],
        imgURL: "",
        roles: null,
        weeks: 0,
        price: 0,
        categories: "",
        languages: [],
        age: 3,
        leaningStyle: "",
        copyright: ""
      };
      this.seo = "";
      this.activeIndex = null;
      this.activeCarePlanStatus = null;
      this.trackContent = {};
    },
    handleAddDataButtonClick(careplan) {
      this.handleEditItemModal(careplan);
    },
  },
  data() {
    return {
      rootPathDoc: this.provider ? `providers/${this.provider.id}/lists/__${this.type}s` : "",
      v2: false,
      listDataDoc: null,
      unsub: null,
      searchIconSVG: require("@/assets/svg/search-icon.svg"),
      success: [],
      modalIdDelete: "delete-modal-id",
      itemTypeDelete: null,
      itemNameDelete: null,
      itemDeleteItemId: null,
      showingMore: false,
      selectedCarePlan: {},
      selectedCarePlanId: null,
      fetching: false,
      itemModal: `item-modal-${this.type}`,
      authorCarePlanVideo: "author-careplan-video",
      refresh: 1,
      showCard: false,
      add: true,
      del: false,
      activeIndex: -1,
      activeCollapse: -1,
      isJustShown: false,
      searchStr: "",
      clear: false,
      trackContent: {},
      seo: "",
      asset: "",
      popupText: "Copy to clipboard",
      uploadingImage: false,
      activeImage: "",
      imgDataUrl: "",
      imgURL: "",
      trackPassing: {},
      careplan: {
        title: "",
        description: {},
        subtitle: "",
        language: "",
        publisher: "",
        published_at: "",
        isbn: "",
        author: "", //Will be part of crew
        editor: "", //Will be part of crew
        illustrator: "", //Will be part of crew
        pages: null,
        reviews: null,
        price: null,
        tools: [], //------------
        series: [],
        carePlanRights: "",
        keywords: [],
        adultContent: "",
        seo: [],
        spheres: [],
        guides: [],
        engines: [],
        connections: [],
        imgURL: "",
        weeks: 0,
        roles: null,
        categories: "",
        languages: null,
        age: 3,
        leaningStyle: "",
        Copyright: ""
      },
      rolesArray: [],
      languagesArray: [],
      activeVideo: null,
      processingVideo: false,
      activeCarePlanStatus: null,
      activeCarePlan: null,
      engines: [],
      addedEngines: [],
      oldEngines: [],
      showEngine: false,
      showUpload: false,
      uploadingScreen: false,
      currIndex: "",
      params: {
        token: "123456798",
        name: "avatar"
      },
      headers: {
        smail: "*_~"
      },
      cornerId: `corner`,
      qrId: `qr`,
      insightsId: `insights`,
      developmentId: `development`,
      dataId: `data`
    };
  },
};
</script>

<style lang="scss" scoped>
.session-foot {
  display: flex;
  justify-content: space-between;
  .stats {
    display: flex;
    align-items: center;
    .ico {
      margin: 0 17px;
    }
  }
  .collapse-foot {
    display: flex;
    justify-content: flex-end;
    .btn-simple-primary {
      background-color: #fff;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 19px;
      justify-content: center;
      padding: 8px 16px;
      border: none;
      display: flex;
      letter-spacing: 0.05em;
      align-items: center;
      color: var(--theme-color);
      margin-left: 16px;
      border-radius: 4px;
      transition: all 0.2s ease-in-out;
      svg {
        margin-right: 16px;
      }
      &:hover {
        background-color: #f3f6f9;
      }
      &.btn-start {
        background-color: #f3f6f9;
        &:hover {
          background-color: #dfdfdf;
          box-shadow: 0px 0px 4px 0px #eee;
        }
      }
    }
  }
}

.areas {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-left: 25%;
  & > div {
    width: 60px;
    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      color: #8d99a0;
    }
    svg {
      cursor: pointer;
    }
  }
}
.small-check {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #8d99a0;
  margin-left: 24px;
}
.custom-control-label {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  color: #474d52;
}
.bv-no-focus-ring {
  position: relative;
  .pre {
    position: absolute;
    left: 15px;
    top: 50%;
    transform: translateY(-50%);
    color: #8d99a0;
  }
  .post {
    position: absolute;
    right: 15px;
    top: 50%;
    color: #8d99a0;
    transform: translateY(-50%);
  }
  input {
    padding-left: 30px;
  }
}
.add-sessions {
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  color: var(--theme-color);
  cursor: pointer;
  position: relative;
}
.add-session {
  .foot {
    margin-top: 24px;
    border-top: 1px solid #dddddd;
    padding: 24px 0 10px 0;
  }
  .close-icon {
    position: absolute;
    top: 24px;
    right: 20px;
    cursor: pointer;
  }
  .btn-round-fill {
    max-width: 160px;
    width: 100%;
  }
  h3 {
    margin-bottom: 0;
    margin-top: 10px;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 33px;
    color: #474d52;
    text-align: center;
  }
  .editor {
    max-width: 100%;
    width: 100%;
    .editor__content {
      .ProseMirror {
        width: 100%;
        border: none;
        box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.8);
        border-radius: 20px;
        padding-left: 30px;
        font-family: Nunito;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 19px;
        color: #474d52;
        background: #fff;
        //border: 1px solid #ddd;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        height: 44px;
        -webkit-box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.8) !important;
        box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.8) !important;
      }
    }
  }
}
.del-session {
  .warning-msg {
    margin: 24px 0;
    p {
      text-align: center;
      margin: 0;
    }
  }
  .btn-round-fill {
    background-color: #ef5c4a;
    border-color: #ef5c4a;
  }
  .btn-simple {
    color: #ef5c4a;
    font-weight: bold;
  }
}

.search {
  cursor: pointer;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #8d99a0;
}
.card-guide {
  box-shadow: none;
}
.sessions {
  margin-top: 20px;
  .card {
    border: none;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    .details {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      & > div {
        margin-right: 18px;
        display: flex;
        align-items: center;
        svg {
          margin-right: 5px;
        }
      }
      .ico {
        margin: 0 17px;
        cursor: pointer;
      }
      .doc-ico {
        margin-left: 0;
      }
      .doc-link {
        color: var(--theme-color);
      }
    }
    .card-text {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      display: flex;
      align-items: center;
      color: #474d52;
    }
    .status-btn {
      display: inline-block;
      margin-right: 15px;
      width: 105px;
      height: 21px;
      font-family: Nunito;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      color: #ffffff;
      background: var(--theme-color);
      text-align: center;
      border: none;
      border-radius: 3px;
    }
  }

  .card-header {
    display: grid;
    grid-template-columns: 1fr 30px;
    align-items: center;
    padding: 0;
    .edit,
    .delete {
      display: none;
      cursor: pointer;
    }
    .btn-collapse {
      padding: 24px;
      text-align: left;
      box-shadow: none;
    }
    &.active {
      grid-template-columns: 1fr 30px 30px 30px;
      .edit,
      .delete {
        display: block;
      }
    }

    border: none;
    box-shadow: none;
    background: none;
  }
  .card-body {
    padding-top: 0;
    img {
      cursor: pointer;
      position: relative;
      // top: 50%;
      right: 4px;
      // -webkit-transform: translateY(-50%);
      // transform: translateY(-50%);
      height: 100px;
      width: 100px;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      background: rgba(85, 126, 251, 0.1);
      border-radius: 8px;
    }
    .session-description {
      left: 5px;
    }
  }
}
.places-lived {
  margin-top: 26px;
  .place__places-lived {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    color: #474d52;
    margin: 6px 15px;
  }
  .del__ico {
    cursor: pointer;
  }
}
.submit-btn {
  border-radius: 28px;
  width: 120px;
}
.roles {
  margin-top: 25px;
}
.tools {
  margin-top: 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #eceff9;
  border-radius: 8px;
  padding: 12px 20px;
  position: relative;
  .extra-tools {
    position: absolute;
    top: 100%;
    width: 100%;
    left: 0;
    background-color: #fff;
    border: 1px solid #eceff9;
    border-top: 0;
    padding: 0px 11px 11px 11px;
    display: flex;
    justify-content: center;
  }
  .ico {
    cursor: pointer;
  }
  .ico,
  img {
    margin: 0 17px;
  }
  & > div {
    flex-wrap: wrap;
    display: flex;
    align-items: center;
    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 24px;
      line-height: 33px;
      color: #5b606c;
      margin: 0 10px 0 0;
    }
  }
  .engine {
    margin-top: 3px;
    background-color: rgba(85, 126, 251, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    font-family: "Nunito", sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    display: flex;
    align-items: center;
    color: var(--theme-color);
    margin-right: 7px;
    svg {
      margin-left: 5px;
      cursor: pointer;
    }
  }

  h6 {
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 33px;
    display: inline;
    color: #5b606c;
    margin-right: 10px;
    //   margin-bottom: 0;
  }
}
.crew {
  margin-top: 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #eceff9;
  border-radius: 8px;
  padding: 12px 20px;
  position: relative;
  .extra-crew {
    position: absolute;
    top: 100%;
    width: 100%;
    left: 0;
    background-color: #fff;
    border: 1px solid #eceff9;
    border-top: 0;
    padding: 0px 11px 11px 11px;
    display: flex;
    justify-content: center;
  }
  .ico {
    cursor: pointer;
  }
  .ico,
  img {
    margin: 0 17px;
  }
  & > div {
    flex-wrap: wrap;
    display: flex;
    align-items: center;
    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 24px;
      line-height: 33px;
      color: #5b606c;
      margin: 0 10px 0 0;
    }
  }
  .engine {
    margin-top: 3px;
    background-color: rgba(85, 126, 251, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    font-family: "Nunito", sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    display: flex;
    align-items: center;
    color: var(--theme-color);
    margin-right: 7px;
    svg {
      margin-left: 5px;
      cursor: pointer;
    }
  }

  h6 {
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 33px;
    display: inline;
    color: #5b606c;
    margin-right: 10px;
    //   margin-bottom: 0;
  }
}
.video-sec {
  margin-left: 15px;
}
.upload-btn {
  cursor: pointer;
  background-color: #fff;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  max-width: 220px;
  height: 50px;
  border: none;
  letter-spacing: 0.05em;
  align-items: center;
  color: var(--theme-color);
  margin-left: 16px;
  border-radius: 4px;
  transition: all 0.2s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
  .content {
    display: flex;
    #blogger-session-video {
      width: 0;
    }
    #guide-session-image {
      width: 0;
    }
    .ico {
      margin-right: 3px;
      img {
        cursor: pointer;
        position: relative;
        top: 50%;
        right: 4px;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        height: 24px;
        width: 24px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        background: rgba(85, 126, 251, 0.1);
        border-radius: 8px;
      }
      svg {
        height: 30px;
      }
    }
    .watch-video {
      margin-top: 5px;
    }
    .btn-content {
      margin-top: 2px;
      font-family: Nunito;
      font-style: normal;
      font-size: 16px;
      line-height: 22px;
      color: var(--theme-color);
    }
  }
}
.upload-btn:focus {
  outline: none;
  box-shadow: none;
}
.description-title {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #8d99a0;
  max-width: 354px;
  width: 100%;
  margin: 18px 0;
  cursor: pointer;
}
.half-fields {
  margin-left: 3px;
}
.fadeHeight-enter-active,
.fadeHeight-leave-active {
  transition: all 0.5s;
  max-height: 230px;
}
.fadeHeight-enter,
.fadeHeight-leave-to {
  opacity: 0;
  max-height: 0px;
  overflow: hidden;
}
</style>